if (!customElements.get('quick-add-drawer')) {
    customElements.define(
        'quick-add-drawer',
        class QuickAddModal extends ModalDialog {
            constructor() {
                super();
                this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
                this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
                this.querySelector('[id^="QuickAddOverlay-"]').addEventListener('click', this.close.bind(this));
                this.setQuickAddLinkClicks();
            }

            setQuickAddLinkClicks() {
                const drawerLinks = document.querySelectorAll('.js-quick-add');
                drawerLinks.forEach((drawerLink) => {
                    drawerLink.setAttribute('role', 'button');
                    drawerLink.setAttribute('aria-haspopup', 'dialog');
                    drawerLink.addEventListener('click', (event) => {
                        event.preventDefault();
                        this.renderContents(drawerLink);
                    });
                    drawerLink.addEventListener('keydown', (event) => {
                        if (event.code.toUpperCase() === 'SPACE') {
                            event.preventDefault();
                            this.renderContents(drawerLink);
                        }
                    });
                });
            }

            setActiveElement(element) {
                this.activeElement = element;
            }

            close() {
                this.classList.remove('active');
                removeTrapFocus(this.activeElement);
                document.body.classList.remove('overflow-hidden');
                document.body.dispatchEvent(new CustomEvent('quickAddClosed'));
            }

            open(opener) {
                if (opener) this.setActiveElement(opener);
                setTimeout(() => {
                    this.classList.add('animate', 'active');
                });

                this.addEventListener(
                    'transitionend',
                    () => {
                        const containerToTrapFocusOn = this.classList.contains('is-empty')
                            ? this.querySelector('.drawer__inner-empty')
                            : this;
                        const focusElement =
                            this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
                        trapFocus(containerToTrapFocusOn, focusElement);
                    },
                    { once: true }
                );

                document.body.classList.add('overflow-hidden');
            }

            renderContents(opener) {
                const originalThis = this;
                opener.closest('.quick-add').classList.add('quick-add--loading');
                const url = new URL(window.location.origin + opener.getAttribute('data-product-url'));
                url.searchParams.append('view', 'drawer');

                fetch(url)
                    .then((response) => response.text())
                    .then((responseText) => {
                        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                        this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
                        this.preventDuplicatedIDs();
                        this.removeDOMElements();
                        this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

                        if (window.Shopify && Shopify.PaymentButton) {
                            Shopify.PaymentButton.init();
                        }

                        if (window.ProductModel) window.ProductModel.loadShopifyXR();

                        this.preventVariantURLSwitching();
                        super.classList.add('active');
                        originalThis.open(opener);
                    })
                    .finally(() => {
                        opener.closest('.quick-add').classList.remove('quick-add--loading');
                    });
            }

            setInnerHTML(element, html) {
                element.innerHTML = html;

                // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
                element.querySelectorAll('script').forEach((oldScriptTag) => {
                    const newScriptTag = document.createElement('script');
                    Array.from(oldScriptTag.attributes).forEach((attribute) => {
                        newScriptTag.setAttribute(attribute.name, attribute.value);
                    });
                    newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
                    oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
                });
            }

            preventVariantURLSwitching() {
                const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
                if (!variantPicker) return;

                variantPicker.setAttribute('data-update-url', 'false');
            }

            removeDOMElements() {
                const modalDialog = this.productElement.querySelectorAll('modal-dialog');
                if (modalDialog) modalDialog.forEach((modal) => modal.remove());
            }

            preventDuplicatedIDs() {
                const sectionId = this.productElement.dataset.section;
                this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
                    sectionId,
                    `quickadd-${sectionId}`
                );
                this.productElement
                    .querySelectorAll('variant-selects, variant-radios, product-info')
                    .forEach((element) => {
                        element.dataset.originalSection = sectionId;
                    });
            }

            removeGalleryListSemantic() {
                const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
                if (!galleryList) return;

                galleryList.setAttribute('role', 'presentation');
                galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
            }
        }
    );
}
